<template>
  <el-dialog
      title="新增企业"
      :visible.sync="dialogVisible"
      width="70%"
      @close="handleClose"
      :close-on-click-modal="false"
  >
    <div class="addContent">
      <el-tabs v-model="activeTab" type="card">
        <!-- 基本信息 -->
        <el-tab-pane label="基本信息" name="basic">
          <el-form
              :model="formData"
              :rules="formRules"
              class="addCompany"
              ref="basicForm"
              label-width="120px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业名称" prop="name">
                  <el-input v-model="formData.name" placeholder="请输入企业名称"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务类型" prop="businessType">
                  <el-select
                      v-model="formData.businessType"
                      placeholder="请选择业务类型"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in businessTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="formData.address" placeholder="请输入详细地址"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经纬度" prop="location">
                  <el-input v-model="formData.location" placeholder="请输入经纬度，如：104.06,30.67"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="所在地区" prop="adcode">
                  <el-cascader
                      v-model="formData.adcode"
                      :options="locationOptions"
                      :props="areaProps"
                      placeholder="请选择地区"
                      style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业联系人" prop="linkman">
                  <el-input v-model="formData.linkman" placeholder="请输入姓名"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input v-model="formData.phone" placeholder="请输入联系电话"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="组织类别" prop="orgType">
                  <el-select
                      v-model="formData.orgType"
                      placeholder="请选择组织类别"
                      style="width: 100%"
                      @change="choseOrgType"
                  >
                    <el-option
                        v-for="item in OrganizationCategory"
                        :key="item.id"
                        :label="item.name"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="成立时间" prop="established">
                  <el-date-picker
                      v-model="formData.established"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业评分" prop="rating">
                  <el-rate
                      v-model="formData.rating"
                      show-score
                      text-color="#ff9900"
                      score-template="{value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业LOGO" prop="image">
                  <div class="loadImg" v-if="formData.logo">
                    <el-image
                        style="width:100%; height: 100%"
                        :src="BasrUrl+formData.logo"
                        fit="cover"/>
                    <div class="delIconBox">
                      <i @click="delImage" class="el-icon-delete"/>
                    </div>
                  </div>
                  <image-upload
                      :image-url="formData.logo"
                      v-else
                      @upload-success="handleUploadSuccess"
                      @upload-change="handleUploadChange"
                      @upload-error="handleUploadError"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业级别" prop="level">
                  <el-switch
                      v-model="formData.level"
                      active-color="#13ce66"
                      inactive-color="grey"
                      active-text="重点企业"
                      inactive-text="普通企业"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="企业简介" prop="description">
              <el-input
                  v-model="formData.description"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入企业简介"
              />
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="员工规模" prop="employees">
                  <el-input v-model="formData.employees" placeholder="请输入员工规模,示例：100-500">
                    <template slot="append">人</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="占地面积" prop="area">
                  <el-input v-model="formData.area" placeholder="请输入占地面积">
                    <template slot="append">平方米</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="年处理能力" prop="capacity">
              <el-input v-model="formData.capacity" placeholder="请输入年处理能力">
                <template slot="append">吨/年</template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <!-- 业务信息 -->
        <el-tab-pane label="业务信息" name="business">
          <el-button
              type="primary"
              size="small"
              @click="addBusiness"
              style="margin-bottom: 15px"
          >
            <i class="el-icon-plus"></i> 添加业务
          </el-button>
          <el-collapse v-model="activeBusiness" accordion>
            <el-collapse-item
                v-for="(business, index) in formData.businesses"
                :key="index"
                :name="index"
            >
              <template slot="title">
                <span style="margin-right: 10px">业务{{ index + 1 }}</span>
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click.stop="removeBusiness(index)"
                />
              </template>
              <el-form
                  :model="business"
                  :rules="businessRules"
                  label-width="100px"
                  ref="businessForms"
              >
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="业务名称" prop="name">
                      <el-input v-model="business.name" placeholder="请输入业务名称"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="年产/处理量" prop="yearProduction">
                      <el-input v-model="business.yearProduction" placeholder="请输入年产量/年处理量">
                        <template slot="append">吨/年</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="年产值" prop="yearValue">
                      <el-input v-model="business.yearValue" placeholder="请输入年产值">
                        <template slot="append">万元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <!--                  <el-col :span="12">-->
                  <!--                    <el-form-item label="年处理量" prop="wasteCollectedValue">-->
                  <!--                      <el-input v-model="business.wasteCollectedValue" placeholder="请输入年处理量">-->
                  <!--                        <template slot="append">吨/年</template>-->
                  <!--                      </el-input>-->
                  <!--                    </el-form-item>-->
                  <!--                  </el-col>-->
                  <el-col :span="12">
                    <el-form-item label="主要设备" prop="equipment">
                      <el-input
                          v-model="business.equipment"
                          placeholder="请输入主要设备，多个设备用逗号分隔"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="业务描述" prop="description">
                  <el-input
                      v-model="business.description"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入业务描述"
                  />
                </el-form-item>

              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>

        <!-- 物料信息 -->
        <el-tab-pane label="物料信息" name="material">
          <el-button
              type="primary"
              size="small"
              @click="addMaterial"
              style="margin-bottom: 15px"
          >
            <i class="el-icon-plus"></i> 添加物料
          </el-button>
          <el-form :model="formData" :rules="MaterialRules" ref="materialForm">
            <el-table
                :data="formData.materials"
                border
                row-class-name="companyCell"
                style="width: 100%"
            >
              <el-table-column prop="name" label="物料名称">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.name'"
                      :rules="MaterialRules.name"
                  >
                    <el-input
                        v-model="scope.row.name"
                        placeholder="请输入物料名称"
                        @blur="validateMaterialField(scope.$index ,'name')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="category" label="物料类别">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.category'"
                      :rules="MaterialRules.category"
                  >
                    <el-input
                        v-model="scope.row.category"
                        placeholder="请输入物料类别"
                        @blur="validateMaterialField(scope.$index ,'category')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="stock" label="当前库存(吨)">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.stock'"
                      :rules="MaterialRules.stock"
                  >
                    <el-input-number
                        v-model="scope.row.stock"
                        :min="0"
                        :step="10"
                        controls-position="right"
                        style="width: 100%"
                        @blur="validateMaterialField(scope.$index ,'stock')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="safetyStock" label="安全库存(吨)">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.safetyStock'"
                      :rules="MaterialRules.safetyStock"
                  >
                    <el-input-number
                        v-model="scope.row.safetyStock"
                        :min="0"
                        :step="10"
                        controls-position="right"
                        style="width: 100%"
                        @blur="validateMaterialField(scope.$index ,'safetyStock')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="capacity" label="存储容量(吨)" width="150">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.capacity'"

                      :rules="MaterialRules.capacity"
                  >
                    <el-input-number
                        v-model="scope.row.capacity"
                        :min="0"
                        :step="10"
                        controls-position="right"
                        style="width: 100%"
                        @blur="validateMaterialField(scope.$index ,'capacity')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="unitValue" label="单位价值(元/吨)" width="180">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'materials.' + scope.$index + '.unitValue'"

                      :rules="MaterialRules.unitValue"
                  >
                    <el-input-number
                        v-model="scope.row.unitValue"
                        :min="0"
                        :step="100"
                        controls-position="right"
                        style="width: 100%"
                        @blur="validateMaterialField(scope.$index ,'unitValue')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      @click="removeMaterial(scope.$index)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-tab-pane>

        <!-- 股份占比 -->
        <el-tab-pane label="股份占比" name="rating">
          <el-button
              type="primary"
              size="small"
              @click="addShareholder"
              style="margin-bottom: 15px"
          >
            <i class="el-icon-plus"></i> 新增持有者
          </el-button>
          <el-form :model="formData" ref="shareholderForm">
            <el-table
                :data="formData.ratio"
                border
                row-class-name="companyCell"
                style="width: 100%"
            >
              <el-table-column prop="Shareholder" label="持有者名称">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'ratio.' + scope.$index + '.Shareholder'"
                  >
                    <el-input
                        v-model="scope.row.Shareholder"
                        placeholder="请输入持有者名称"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="ratio" label="持有比例">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'ratio.' + scope.$index + '.ratio'"
                  >
                    <el-input
                        v-model="scope.row.ratio"
                        placeholder="请输入持有比例，如：30%"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      @click="removeShareholder(scope.$index)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-tab-pane>

        <!-- 证书信息 -->
        <el-tab-pane label="资质证书" name="certificate">
          <el-button
              type="primary"
              size="small"
              @click="addCertificate"
              style="margin-bottom: 15px"
          >
            <i class="el-icon-plus"></i> 添加证书
          </el-button>
          <el-row :gutter="20">
            <el-col
                v-for="(cert, index) in formData.certificates"
                :key="index"
                :span="6"
                style="margin-bottom: 20px"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div class="loadImg" v-if="cert.image">
                  <el-image
                      style="width:100%; height: 100%"
                      :src="BasrUrl+cert.image"
                      fit="cover"/>
                  <div class="delIconBox">
                    <i @click="delCertImage(index)" class="el-icon-delete"/>
                  </div>
                </div>
                <image-upload
                    :image-url="cert.image"
                    v-else
                    @upload-success="(result) => handleCertSuccess(result, index)"
                    @upload-change="(result) => handleCertChange(result, index)"
                    @upload-error="handleCertError"
                />
                <div style="padding: 14px;">
                  <el-input show-word-limit maxlength="100" v-model="cert.name" placeholder="证书名称"/>
                  <el-input show-word-limit maxlength="50" style="margin-top: 10px" v-model="cert.certNumber"
                            placeholder="证书编号"/>
                  <div class="bottom clearfix" style="margin-top: 10px">
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="removeCertificate(index)"
                        style="float: right"
                    />
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </div>
    <div class="isShow"  style="text-align: center; margin-bottom: 50px">
      新增业务请到电脑端进行操作！！！
    </div>
  </el-dialog>
</template>

<script>
import {getAreaTreeData} from '@/API/news/news';
import {addCompony} from '@/API/news/news';
import ImageUpload from '@/components/ImageUpload/ImageUpload.vue';

export default {
  name: 'AddCompanyDialog',
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // 监听父组件传递的visible变化
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      dialogVisible: this.visible,  // 创建本地副本
      BasrUrl: process.env.VUE_APP_BASE_URL,
      activeTab: 'basic',
      activeBusiness: '0',
      areaProps: {
        value: 'adcode',
        label: 'name',
        checkStrictly: true,
      },
      formData: this.getDefaultFormData(),
      // 表单验证规则
      formRules: {
        name: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        businessType: [
          {required: true, message: '请选择业务类型', trigger: 'change'}
        ],
        phone: [
          {required: false, message: '请输入联系电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的电话号码', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '请输入企业简介', trigger: 'blur'}
        ],
        location: [
          {required: true, message: '请输入企业位置所在经纬度,参考网址：https://lbs.amap.com/tools/picker', trigger: 'blur'},
          {
            pattern: /^-?\d{1,3}\.\d{1,6},\s*-?\d{1,3}\.\d{1,6}$/,
            message: '请输入正确的经纬度格式，如：104.06,30.67',
            trigger: 'blur'
          }
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'blur'}
        ],
        adcode: [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        certNumber: [
          {required: true, message: '请输入证书编号', trigger: 'blur'}
        ],
        orgType: [
          {required: true, message: '请选择组织类别', trigger: 'change'}
        ],
        established: [
          {required: true, message: '请选择成立时间', trigger: 'change'}
        ],
        employees: [
          {required: true, message: '请输入员工规模', trigger: 'change'}
        ],
        area: [
          {required: true, message: '请输入占地面积', trigger: 'blur'},
          {pattern: /^[0-9]\d*(\.\d+)?$/, message: '必须为正数'}
        ],
        capacity: [
          {required: true, message: '请输入年处理能力', trigger: 'blur'},
          {pattern: /^[0-9]\d*(\.\d+)?$/, message: '必须为正数'}
        ]
      },
      businessRules: {
        name: [
          {required: true, message: '请输入业务名称', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '请输入业务描述', trigger: 'blur'}
        ],
        yearProduction: [
          {required: true, message: '请输入年产量', trigger: 'blur'},
          {pattern: /^[0-9]\d*(\.\d+)?$/, message: '必须为正数'}
        ],
        yearValue: [
          {pattern: /^[0-9]\d*(\.\d+)?$/, message: '必须为正数'}
        ],
        equipment: [
          {required: true, message: '请输入主要设备', trigger: 'blur'}
        ],
      },
      MaterialRules: {
        name: [
          {required: true, message: '请输入物料名称', trigger: 'blur'},
          {min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur'}
        ],
        category: [{required: true, message: '请输入物料类别', trigger: 'blur'}],
        stock: [{required: true, message: '请输入当前库存', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const index = rule.field.split('.')[1];
              const material = this.formData.materials[index];
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入当前库存'));
              } else if (value < 0) {
                callback(new Error('库存不能为负数'));
              } else if (value > material.safetyStock) {
                callback(new Error('当前库存不能超过安全库存'));
              } else if (value > 99999999) {
                callback(new Error('当前库存输入范围为0~99999999'));
              } else {
                callback();
              }
            }
          }
        ],
        safetyStock: [
          {required: true, message: '请输入安全库存', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const index = rule.field.split('.')[1];
              const material = this.formData.materials[index];
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入安全库存'));
              } else if (value < 0) {
                callback(new Error('安全库存不能为负数'));
              } else if (value > material.capacity) {
                callback(new Error('安全库存不能超过存储容量'));
              } else if (value > 99999999) {
                callback(new Error('安全库存输入范围为0~99999999'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        capacity: [
          {required: true, message: '请输入存储容量', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const index = rule.field.split('.')[1];
              const material = this.formData.materials[index];
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入存储容量'));
              } else if (value < 0) {
                callback(new Error('存储容量不能为负数'));
              } else if (value < material.safetyStock) {
                callback(new Error('存储容量不能小于安全库存'));
              } else if (value > 99999999) {
                callback(new Error('存储容量输入范围为0~99999999'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        unitValue: [
          {required: true, message: '请输入单位价值', trigger: 'blur'},
          {type: 'number', min: 0, max: 99999999, message: '价值输入范围为0~99999999', trigger: 'blur'}
        ]
      },
      businessTypes: [
        {value: 'recycleStation', label: '回收网点'},
        {value: 'transferStation', label: '中转站'},
        {value: 'sortingCenter', label: '分拣中心'},
        {value: 'wasteEnterprise', label: '利废企业'},
        {value: 'dismantlingCenter', label: '二手交易市场'},
        {value: 'industrialPark', label: '产业园区/集散市场'},
        {value: 'other', label: '其他'}
      ],
      locationOptions: [],
      OrganizationCategory: [
        {
          id: 15,
          typeId: 3,
          name: "省社",
          value: "1030",
        },
        // {
        //   id: 16,
        //   typeId: 3,
        //   name: "全省",
        //   value: "1031",
        // },
        {
          id: 17,
          typeId: 3,
          name: "非省社",
          value: "1032",
        },
      ],
    };
  },
  created() {
    this.getAreaData();
  },
  methods: {
    delImage() {
      this.formData.logo = '';
      this.$message.success('图片清理成功，请重新上传');
    },
    delCertImage(index) {
      this.formData.certificates[index].image = '';
      this.$message.success('图片清理成功，请重新上传');
    },
    getDefaultFormData() {
      return {
        name: '',
        businessType: '',
        location: '',
        phone: '',
        adcode: [],
        rating: 4.0,
        description: '',
        established: '',
        ratio: [],
        employees: '',
        area: '',
        capacity: '',
        logo: '',
        level: false,
        businesses: [{
          name: '',
          description: '',
          yearProduction: '',
          yearValue: '',
          wasteCollectedValue: '',
          equipment: ''
        }],
        materials: [],
        certificates: [],
        orgType: '',
        orgTypeName: '',
        linkman: '',
        address: '',
        status: 2
      }
    },
    handleClose() {
      this.$emit('update:visible', false)  // 通知父组件更新
      this.resetForm()
    },
    resetForm() {
      console.log('close')
      this.visible = false;
      this.formData = this.getDefaultFormData();
      if (this.$refs.basicForm) {
        this.$refs.basicForm.resetFields();
      }
    },
    choseOrgType(val) {
      const selectedOrg = this.OrganizationCategory.find(
          (item) => item.value === val,
      );
      if (selectedOrg) {
        this.formData.orgTypeName = selectedOrg.name;
      }
    },
    // 新增股东
    addShareholder() {
      this.formData.ratio.push({
        Shareholder: '',
        ratio: ''
      })
    },
    // 移除股东
    removeShareholder(index) {
      this.formData.ratio.splice(index, 1)
    },
    addCertificate() {
      this.formData.certificates.push({
        name: '',
        certNumber: '',
        image: '',
      });
    },
    removeCertificate(index) {
      this.formData.certificates.splice(index, 1);
    },
    handleCertSuccess(result, index) {
      this.formData.certificates[index].image = result.url;
      this.$message.success('图片上传成功');
    },
    handleCertChange(result, index) {
      this.formData.certificates[index].image = result.url;
      this.$message.success('清理成功，请重新上传');
    },
    handleCertError() {
      this.$message.error('图片上传失败');
    },
    addBusiness() {
      this.formData.businesses.push({
        name: '',
        description: '',
        yearProduction: '',
        yearValue: '',
        wasteCollectedValue: '',
        equipment: '',
      });
      this.activeBusiness = (this.formData.businesses.length - 1).toString();
    },
    removeBusiness(index) {
      this.formData.businesses.splice(index, 1);
      if (this.formData.businesses.length > 0) {
        this.activeBusiness = Math.min(
            index,
            this.formData.businesses.length - 1,
        ).toString();
      }
    },
    addMaterial() {
      this.formData.materials.push({
        name: '',
        category: '',
        stock: 0,
        safetyStock: 0,
        capacity: 0,
        unitValue: 0,
      });
    },
    removeMaterial(index) {
      this.formData.materials.splice(index, 1);
    },
    handleRowClick(row, column, event) {
      if (column && column.label === '操作') return;
      this.$refs.materialForm.validate();
    },
    validateField(prop) {
      this.$refs.materialForm.validateField(prop);
    },
    getAreaData() {
      let code = 510000,
          recursion = 1;
      getAreaTreeData(code, recursion).then((res) => {
        this.locationOptions = res.data;
      });
    },
    handleUploadSuccess({url, fileName}) {
      this.formData.logo = url;
      this.$message.success('图片上传成功');
    },
    handleUploadChange({url, fileName}) {
      this.formData.logo = url;
      this.$message.success('清理成功，请重新上传');
    },
    handleUploadError(error) {
      this.$message.error('图片上传失败');
    },
    validateMaterialField(index, field) {
      const prop = `materials.${index}.${field}`;
      this.$refs.materialForm.validateField(prop);

      // 如果是安全库存或容量字段，需要同时校验另一个相关字段
      if (field === 'safetyStock' || field === 'capacity') {
        const relatedField = field === 'safetyStock' ? 'capacity' : 'safetyStock';
        const relatedProp = `materials.${index}.${relatedField}`;
        this.$refs.materialForm.validateField(relatedProp);
      }
    },
    submitForm() {
      this.$refs.basicForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请完善基本信息');
          this.activeTab = 'basic';
          return false;
        }

        if (this.formData.businesses.length === 0) {
          this.$message.error('请至少添加一项业务');
          this.activeTab = 'business';
          return false;
        }

        let businessValid = true;
        this.formData.businesses.forEach((business) => {
          if (
              !business.name ||
              !business.description ||
              !business.yearProduction
          ) {
            businessValid = false;
          }
        });

        if (!businessValid) {
          this.$message.error('请完善业务信息');
          this.activeTab = 'business';
          return false;
        }

        if (this.formData.materials.length === 0) {
          this.$message.error('请至少添加一项物料');
          this.activeTab = 'material';
          return false;
        }

        let materialsValid = true;
        this.formData.materials.forEach((material) => {
          if (
              !material.name ||
              !material.category ||
              !material.stock ||
              !material.safetyStock ||
              !material.capacity ||
              !material.unitValue
          ) {
            materialsValid = false;
          }
        });

        if (!materialsValid) {
          this.$message.error('请完善物料信息');
          this.activeTab = 'material';
          return false;
        }
        const submitData = {
          ...this.formData,
          // 将股份占比数组转换为字符串
          ratio: JSON.stringify(this.formData.ratio),
          level: this.formData.level ? 1 : 0,
          adcode: this.formData.adcode[this.formData.adcode.length - 1]
        }
        addCompony(submitData).then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功，待管理审核！');
            this.$emit('refresh');
            this.$emit('update:visible', false);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 768px) {
  .addContent {
    display: none;
  }
  .isShow{
    display: block !important;
  }
}
.isShow{
  display: none;
}
.loadImg {
  position: relative;
  height: 180px;
  width: 100%;

  .delIconBox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 100;
    color: #ffffff;
    cursor: pointer;
    display: none;
  }
}

.loadImg:hover {
  .delIconBox {
    display: flex;
  }
}

.el-rate {
  height: 40px;
  display: flex;
  align-items: center;

  .el-rate__item {
    line-height: 40px;
  }
}

/deep/ .companyCell {
  .cell {
    overflow: unset;
  }
}

/* 可以根据需要添加样式 */
</style>
